<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
        <v-row dense>
            <v-col cols="12" sm="12">
                <v-card class="pa-2">
                    <v-card-title>Client Monthly Checklist</v-card-title>
                    <v-divider class="ma-2"></v-divider>

                    <v-card-subtitle>Select Date Range</v-card-subtitle>

                    <v-layout row wrap>
                        <v-flex xs12 sm3 class="pa-2">
                            <v-menu
                                ref="calendarMenu"
                                v-model="calendarMenu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="startDate"
                                    label="Start Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules='requiredField'
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="startDate"
                                no-title
                                scrollable
                                :rules='requiredField'

                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="calendarMenu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(startDate)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 sm3 class="pa-2">
                            <v-menu
                                ref="calendar2Menu"
                                v-model="calendar2Menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="endDate"
                                    label="End Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules='requiredField'

                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="endDate"
                                no-title
                                scrollable
                                :rules='requiredField'

                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="calendar2Menu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.calendar2Menu.save(endDate)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 sm3 class="pa-2">
                            <v-select 
                                label="Select a Client"
                                :items="clients"
                                item-text="Name"
                                item-value="_id"
                                v-model="ClientID"
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 sm2 class="ma-4">
                            <v-btn @click="generateLists()">Search</v-btn>
                        </v-flex>
                    </v-layout>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Daily Reports (ADL's)
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="adlscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="adlsincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.ClientID.Name}}</td>
                                            <td>{{adl.Service.ServiceItem}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>

                                                <router-link :to="{name: 'ADL'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(adl)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>       
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Support Strategies
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="supportscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="supportsincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Goal
                                            </th>
                                            <th>
                                                Start Date
                                            </th>
                                            <th>
                                                End Date
                                            </th>

                                            <th>
                                                Review Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="support in supports"
                                            :key="support._id"
                                        >
                                            <td>{{support.Client}}</td>
                                            <td>{{support.Goal}}</td>
                                            <td>{{support.StartDate}}</td>
                                            <td>{{support.EndDate}}</td>
                                            <td>{{support.ReviewDate}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(support)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Behavior Reporting
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="behaviorscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="behaviorsincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Behavior
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="behavior in behaviors"
                                            :key="behavior._id"
                                        >
                                            <td>{{behavior.Client}}</td>
                                            <td>{{behavior.Behavior}}</td>
                                            <td>{{behavior.StartDate}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(behavior)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Client Finance Ledger
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="financescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="financesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Action
                                            </th>
                                            <th>
                                                Amount
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="finance in finances"
                                            :key="finance._id"
                                        >
                                            <td>{{finance.Client}}</td>
                                            <td>{{finance.Action}}</td>
                                            <td>{{finance.Amount}}</td>
                                            <td>{{finance.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(finance)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Medication Administration Record (MAR)
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="marscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="marsincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>
                                                Medication
                                            </th>
                                            <th>
                                                Signature
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="mar in mars"
                                            :key="mar._id"
                                        >
                                            <td>{{mar.ClientID.Name}}</td>
                                            <td>{{mar.Date}}</td>
                                            <td>{{mar.Medication.Medication}}</td>
                                            <td>{{mar.Signature}}</td>
                                            <td>
                                                <router-link :to="{name: 'MAR'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(mar)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Controlled Substance Count Sheet
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="substancescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="substancesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Medication Hand Off Sheet
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="handOffscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="handOffsincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Medication Change Form
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="changescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="changesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Medical Visit Forms
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="visitscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="visitsincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Visit Type
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="visit in visits"
                                            :key="visit._id"
                                        >
                                            <td>{{visit.ClientID.Name}}</td>
                                            <td>{{visit.VisitType}}</td>
                                            <td>{{visit.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MedVisit'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(visit)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Standing Orders
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="orderscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="ordersincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Inventory Updates
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="inventoriescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="inventoriesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Off Site Visit Form
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="offSitescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="offSitesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Menu
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="menuscomplete" class="green--text">done</v-icon>
                                <v-icon v-if="menusincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(item)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Activity Calendar
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="activitiesComplete==true" class="green--text">done</v-icon>
                                <v-icon v-if="activitiesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Event
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="event in events"
                                            :key="event._id"
                                        >
                                            <td>{{event.Client.Name}}</td>
                                            <td>{{event.Event}}</td>
                                            <td>{{event.StartDate}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(event)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>  
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Monthly Summary
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="summariescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="summariesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Client
                                            </th>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            <th>

                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="summary in summaries"
                                            :key="summary._id"
                                        >
                                            <td>{{summary.ClientID.Name}}</td>
                                            <td>{{summary.Summary}}</td>
                                            <td>{{summary.StartDate}}</td>
                                            <td>
                                                <router-link :to="{name: 'MonthlySummaries'}">
                                                <v-btn
                                                    x-small
                                                    class="white--text"
                                                    color="#2b3990"
                                                    @click="getClientID(summary)"
                                                >
                                                    view
                                                </v-btn>
                                                </router-link>          
                                            </td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-if="show">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Consent For Services
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                Status: 
                                <v-icon v-if="servicescomplete" class="green--text">done</v-icon>
                                <v-icon v-if="servicesincompleted" class="red--text">cancel</v-icon>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>
                                                Service Item
                                            </th>
                                            <th>
                                                Date
                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="adl in adls"
                                            :key="adl._id"
                                        >
                                            <td>{{adl.Service}}</td>
                                            <td>{{adl.Date}}</td>
                                            
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>

                        </v-expansion-panel>
                    </v-expansion-panels>
                    
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>
<script>
// import ClientNav from '../../components/ClientNav'
// import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import axios from 'axios'

const url = require("../../client_config/config").url;

    export default {
        components: { 
        // ClientNav,
        // ClientSide,
        Foot,
        
    },
    data: () => ({
        ClientID: "",
        msg: false,
        text: "",
        calendarMenu: false,
        calendar2Menu: false,
        startDate: "",
        endDate: "",
        show: false,
        clients: [],
        adls: [],
        supports: [],
        behaviors: [],
        finances: [],
        mars: [],
        substances: [],
        handOffs: [],
        changes: [],
        visits: [],
        orders: [],
        inventories: [],
        offSites: [],
        menus: [],
        events: [],
        summaries: [],
        services: [],
        adlscomplete: false,
        adlsincompleted: false,
        supportscomplete: false,
        supportsincompleted: false,
        behaviorscomplete: false,
        behaviorsincompleted: false,
        financescomplete: false,
        financesincompleted: false,
        marscomplete: false,
        marsincompleted: false,
        substancescomplete: false,
        substancesincompleted: false,
        handOffscomplete: false,
        handOffsincompleted: false,
        changescomplete: false,
        changesincompleted: false,
        visitscomplete: false,
        visitsincompleted: false,
        orderscomplete: false,
        ordersincompleted: false,
        inventoriescomplete: false,
        inventoriesincompleted: false,
        offSitescomplete: false,
        offSitesincompleted: false,
        menuscomplete: false,
        menusincompleted: false,
        activitiesComplete: false,
        activitiesincompleted: false,
        summariescomplete: false,
        summariesincompleted: false,
        servicescomplete: false,
        servicesincompleted: false,
        requiredField: [
        v => !!v || 'This is required'
        ],
        client: "",
        
    }),

    created() {
      this.getClients();

    },

    methods: {
        generateLists() {
        console.log(this.startDate + " is start")
        console.log(this.endDate + " is end")

            if(this.show == false) {
                this.show = true;
            } else {
                this.show = false
            }
            if (this.ClientID==""){
                axios.get(`${url}/monthlyChecklist/${this.startDate}/${this.endDate}`).then((response) => {
                this.adls = response.data.adls;
                this.behaviors = response.data.behav;
                this.mars = response.data.mar;
                this.visits = response.data.visit;
                this.finances = response.data.finance;
                this.summaries = response.data.summary;
                this.events = response.data.cal;
                this.supports = response.data.support;

                if ( this.events.length == 0){
                    this.activitiesComplete = true
                } else {
                    this.activitiesincompleted = true
                }

                if ( this.adls.length == 0){
                    this.adlscomplete = true

                } else {
                    this.adlsincompleted = true
                }

                if ( this.supports.length == 0){
                    this.supportscomplete = true
                    
                } else {
                    this.supportsincompleted = true
                }

                if ( this.behaviors.length >= 30){
                    this.behaviorscomplete = true
                    
                } else {
                    this.behaviorsincompleted = true
                }
                
                if ( this.finances.length == 0){
                    this.financescomplete = true
                    
                } else {
                    this.financesincompleted = true
                }

                if ( this.mars.length == 0){
                    this.marscomplete = true
                    
                } else {
                    this.marsincompleted = true
                }

                if ( this.substances.length == 0){
                    this.substancescomplete = true
                    
                } else {
                    this.substancesincompleted = true
                }
                
                if ( this.handOffs.length == 0){
                    this.handOffscomplete = true
                    
                } else {
                    this.handOffsincompleted = true
                }

                if ( this.changes.length == 0){
                    this.changescomplete = true

                } else {
                    this.changesincompleted = true
                }

                if ( this.visits.length == 0){
                    this.visitscomplete = true

                } else {
                    this.visitsincompleted = true
                }
                
                if ( this.orders.length == 0){
                    this.orderscomplete = true

                } else {
                    this.ordersincompleted = true
                }

                if ( this.inventories.length == 0){
                    this.inventoriescomplete = true

                } else {
                    this.inventoriesincompleted = true
                }

                if ( this.offSites.length == 0){
                    this.offSitescomplete = true

                } else {
                    this.offSitesincompleted = true
                }

                if ( this.menus.length == 0){
                    this.menuscomplete = true

                } else {
                    this.menusincompleted = true
                }

                if ( this.summaries.length == 0){
                    this.summariescomplete = true
                } else {
                    this.summariesincompleted = true
                }

                if ( this.services.length == 0){
                    this.servicescomplete = true
                } else {
                    this.servicesincompleted = true
                }
               
            })
            } else {

            
            axios.get(`${url}/monthlyChecklist/${this.ClientID}/${this.startDate}/${this.endDate}`).then((response) => {
                this.adls = response.data.adls;
                this.behaviors = response.data.behav;
                this.mars = response.data.mar;
                this.visits = response.data.visit;
                this.finances = response.data.finance;
                this.summaries = response.data.summary;
                this.events = response.data.cal;
                this.supports = response.data.support;

                if ( this.events.length == 0){
                    this.activitiesComplete = true
                } else {
                    this.activitiesincompleted = true
                }

                if ( this.adls.length == 0){
                    this.adlscomplete = true

                } else {
                    this.adlsincompleted = true
                }

                if ( this.supports.length == 0){
                    this.supportscomplete = true
                    
                } else {
                    this.supportsincompleted = true
                }

                if ( this.behaviors.length >= 30){
                    this.behaviorscomplete = true
                    
                } else {
                    this.behaviorsincompleted = true
                }
                
                if ( this.finances.length == 0){
                    this.financescomplete = true
                    
                } else {
                    this.financesincompleted = true
                }

                if ( this.mars.length == 0){
                    this.marscomplete = true
                    
                } else {
                    this.marsincompleted = true
                }

                if ( this.substances.length == 0){
                    this.substancescomplete = true
                    
                } else {
                    this.substancesincompleted = true
                }
                
                if ( this.handOffs.length == 0){
                    this.handOffscomplete = true
                    
                } else {
                    this.handOffsincompleted = true
                }

                if ( this.changes.length == 0){
                    this.changescomplete = true

                } else {
                    this.changesincompleted = true
                }

                if ( this.visits.length == 0){
                    this.visitscomplete = true

                } else {
                    this.visitsincompleted = true
                }
                
                if ( this.orders.length == 0){
                    this.orderscomplete = true

                } else {
                    this.ordersincompleted = true
                }

                if ( this.inventories.length == 0){
                    this.inventoriescomplete = true

                } else {
                    this.inventoriesincompleted = true
                }

                if ( this.offSites.length == 0){
                    this.offSitescomplete = true

                } else {
                    this.offSitesincompleted = true
                }

                if ( this.menus.length == 0){
                    this.menuscomplete = true

                } else {
                    this.menusincompleted = true
                }

                if ( this.summaries.length == 0){
                    this.summariescomplete = true
                } else {
                    this.summariesincompleted = true
                }

                if ( this.services.length == 0){
                    this.servicescomplete = true
                } else {
                    this.servicesincompleted = true
                }
               
            })
            }

        },

        getClients () {
        axios.get(`${url}/clients`).then(async res => {
          this.clients = res.data.clients;
          
        });      
      },

      getClientID(item) {
      this.client = item.ClientID._id;
      window.localStorage.setItem('clientId', this.client)
      console.log(this.client)
    },
    }



}


</script>



support strategies - not expired
behavior report - one needs to be filled out each day
finance needs to balanced and needs to have client and staff signatures
mar is signed unless exception is absent
controlled substance count sheet - needs to be counted/verified each shift
med hand off sheet if the leave with meds
med change form - had a medication change on med visit
med visit - if they went to any med appointment. *** must have something uploaded. 
standing order - over the counter medication for the clients. those get added in document library
inventory updates 
off site visit form - if they go any place 
menu - add it to calendar and verify that it has been completed
activity calendar - if it exists. 
consent for services - make sure this document isn't expired. 
